import React, { useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import CartStore from '../../stores/Cart';

import Heart from '../../images/heart.svg';
import FullHeart from '../../images/heart_full.svg';

import classNames from 'classnames';

interface Props {
  cart?: CartStore;
  productSlug: string;
  type?: 'button' | 'icon';
  componentClassName?: string;
}

function FavouriteIcon({
  cart,
  productSlug,
  type = 'icon',
  componentClassName,
}: Props) {
  const [favourite, setFavourite] = useState(false);

  const isFavourite = useMemo(
    () => !!cart?.favourites?.some((p) => p.slug === productSlug),
    [cart?.favourites, productSlug],
  );

  useEffect(() => {
    if (!cart?.initialized) return;
    setFavourite(isFavourite);
  }, [cart?.initialized, isFavourite]);

  const onFavouriteClick = async () => {
    if (!cart) return;
    await cart.toggleFavourite(productSlug);
    setFavourite(!!cart.favourites?.some((p) => p.slug === productSlug));
  };

  const img = (
    <img
      className={classNames(
        'm-2',
        type === 'button' ? 'w-6 h-6' : 'w-4 h-4',
        'cursor-pointer',
      )}
      src={favourite ? FullHeart : Heart}
      onClick={type === 'button' ? undefined : onFavouriteClick}
      alt={favourite ? 'Eemalda lemmikutest' : 'Lisa lemmikutesse'}
      title={favourite ? 'Eemalda lemmikutest' : 'Lisa lemmikutesse'}
    />
  );

  return (
    <div
      className={classNames(
        'flex items-center cursor-pointer',
        componentClassName,
      )}
    >
      {type === 'button' ? (
        <button onClick={onFavouriteClick} className="cursor-pointer">
          {img}
        </button>
      ) : (
        img
      )}
    </div>
  );
}

export default inject('cart')(observer(FavouriteIcon));
